/**
 * Layout notes constants for campaign configurations
 */
export const LAYOUT_NOTES = {
  // UI/UX enhancements
  HAIR_COLOR_DRAWN: 'hair-color-drawn', // Uses drawn images for hair color selection screen (PROD-2325)
  THREE_SCREENS_NEW: 'three-screens-new', // Updated first three screens with new girls content (PROD-2317)
  PERSONALITY_VALUES: 'personality-values', // Enhanced personality selection screen with updated values (PROD-2289)
  SEND_PHOTOS_V2: 'send-photos-v2', // Updated photo sharing functionality in safe funnel (MAIN-1083)
  BODY_SHAPE_SPORTS: 'body-shape-sports', // Sports-themed body shape selection in safe funnel (MAIN-1083)
  SAFE_INTERACTIONS: 'safe-interactions', // Shows safe interaction options instead of all interactions

  // Character-specific welcome screens
  JIA: 'jia', // Character Jia welcome screen variant - changes photos in dominant onboarding screens (MAIN-724)
  WELCOME_V2: 'welcome-v2', // Updated welcome screen design for dominant funnels (MAIN-724)
  LUCY: 'lucy', // Character Lucy welcome screen variant - changes photos in dominant onboarding screens (MAIN-724)
  BRETTY1: 'bretty1', // Character Bretty1 welcome screen variant (MAIN-812)
  BRETTY3: 'bretty3', // Character Bretty3 welcome screen variant (MAIN-812)
  OLIVIA2: 'olivia2', // Character Olivia2 welcome screen variant (MAIN-812)
  XINHUA1: 'xinhua1', // Character Xinhua1 welcome screen variant (MAIN-812)

  // Story/Scene progression for roleplay funnels
  S1: 's1', // Story scene 1 for roleplay w2w funnel (MAIN-614)
  S2: 's2', // Story scene 2 for roleplay w2w funnel (MAIN-614)
  S3: 's3', // Story scene 3 for roleplay w2w funnel (MAIN-614)
  S4: 's4', // Story scene 4 for roleplay w2w funnel (MAIN-614)
  S5: 's5', // Story scene 5 for roleplay w2w funnel (MAIN-614)
  S6: 's6', // Story scene 6 for roleplay w2w funnel (MAIN-614)

  WelcomeG3: 'g3', // G3 screen for own-ai-man-g layout (MAIN-499)
  WelcomeG5: 'g5', // G5 screen for own-ai-man-g layout (MAIN-499)
  WelcomeG6: 'g6', // G6 screen for own-ai-man-g layout (MAIN-499)
  WelcomeG9: 'g9', // G9 screen for own-ai-man-g layout (MAIN-499)
  WelcomeG12: 'g12', // G12 screen for own-ai-man-g layout (MAIN-499)
  WelcomeG15: 'g15', // G15 screen for own-ai-man-g layout (MAIN-499)

  // Company branding
  REMOVE_DIALOGUE_REFERENCES: 'remove-dialogue-references', // Removes all Dialogue company references and branding
  LURE_AI_BRANDING: 'lure-ai-branding', // Uses Lure AI branding instead of Dialogue
  LURE_APP_BRANDING: 'lure-app-branding', // Uses Lure App branding instead of Dialogue
  TOTAL_REAL_BOYS_SCREENS: 'total-real-boys-screens', // Uses compact variants for age, ethnicity and other screens

  // Multigender layout gender screen variants
  GENDER_GIRLS_2: 'gender-girls-2', // New girls on first screen (screen №2) for multigender layout (MAIN-1451)
  GENDER_GIRLS_4: 'gender-girls-4', // New girls on first screen (screen №4) for multigender layout (MAIN-1451)
  GENDER_GIRLS_5: 'gender-girls-5', // New girls on first screen (screen №5) for multigender layout (MAIN-1451)
  GENDER_KELLY: 'gender-kelly', // Kelly character on gender screen for multigender layout (picture-6.png)
  GENDER_KELLY_SHY: 'gender-kelly-shy', // Kelly shy variant on gender screen (picture-9.png)
  GENDER_KELLY_WHITE: 'gender-kelly-white', // Kelly white variant on gender screen (picture-10.png)

  // Email screen enhancements
  EMAIL_STATIC_IMAGE: 'email-static-image', // Uses static image instead of dynamic photo tiles on email screen

  // Review cards
  REVIEWS_APP_STORE: 'reviews-app-store', // Uses App Store reviews content in ReviewCardsCompatibility component

  // TM layout character variants
  TM_MAXIM: 'tm-maxim', // Uses Maxim character images and content in OwnAIMan_TM layout
  TM_THOMAS: 'tm-thomas', // Uses Thomas character images and content in OwnAIMan_TM layout

  // Terms and conditions
  REQUIRE_TERMS_CHECKBOX: 'require-terms-checkbox', // Requires explicit checkbox agreement on Security screen (MAIN-1746)
} as const;

/**
 * Paywall notes constants for campaign configurations
 */
export const PAYWALL_NOTES = {
  // Timer and visual elements
  FIXED_TIMER: 'fixed-timer', // Timer functionality - shows countdown timer on paywall
  FIXED_TIMER_V2: 'fixed-timer-v2', // Timer V2 - "One-time offer for:" + CLAIM OFFER button
  FIXED_TIMER_SECOND_PLAN: 'fixed-timer-second-plan', // Timer functionality - shows countdown timer on paywall, scrolls to second plan section
  PERSONALIZED_HEADER: 'personalized-header', // Personalized header with username and gender-based pronoun (her/him)
  APP_ICON_BG: 'app-icon-bg', // Shows app icon as background element on paywall
  FOUR_NSFW_GIRL: '4-nsfw-girl', // Displays 4 specific NSFW girl images on paywall

  // Character-specific variants
  TRANS: 'trans', // Transsexual funnel variant with transsexual images and trans success page (MAIN-791)
  JIA: 'jia', // Character named Jia variant - changes photos in dominant onboarding screens (MAIN-724)
  LUCY: 'lucy', // Character named Lucy variant - changes photos in dominant onboarding screens (MAIN-724)

  // Payment and promotional features
  PROMO_CODE: 'promo-code', // Enables promo code input field on paywall
  PROD_2506: 'PROD-2506', // Man's campaign with updated photos and promo code functionality
  MAIN_697: 'MAIN-697', // Long and short w2w campaigns with purple gradient theme

  // Subscription plan features
  VIP_PLANS_ACCESS: 'vip-plans-access', // Enables VIP subscription plans (MAIN-952, MAIN-1061)
  SAFE_PLANS_ACCESS: 'safe-plans-access', // Enables safe subscription plans without adult content
  ONE_NIGHT_STAND: 'one-night-stand', // One-night stand themed paywall (MAIN-952, MAIN-1061)
  ONE_DAY_VIP_SELECT_PLAN: 'one-day-vip-select-plan', // One-day VIP plan selection (MAIN-1061)
  SIMPLE_SELECT_PLAN: 'simple-select-plan', // Simplified plan selection interface(MAIN-1034)
  OFFER_CARD_SELECT_PLAN: 'offer-card-select-plan', // Offer card plan
  SHOW_COINS_PAYWALL_MODAL: 'show-coins-paywall-modal', // Shows coins paywall modal instead of inline payment elements
  COINS_UPSALE_V1: 'coins-upsale-v1', // Uses v1 images for coins upsale modal
  COINS_UPSALE_V2: 'coins-upsale-v2', // Uses v2 images for coins upsale modal
  COINS_UPSALE_V3: 'coins-upsale-v3', // Uses v3 images for coins upsale modal

  // Content customization
  REAL_MAN_PHOTOS: 'real-man-photos', // Uses real man photos instead of generated ones (MAIN-1046)
  REAL_GIRLS_PHOTOS: 'real-girls-photos', // Uses real girls photos instead of generated ones (MAIN-1108)
  REAL_GIRLS_PHOTOS_V2: 'real-girls-photos-v2', // Uses real girls photos v2 (stored in v3 folder) instead of generated ones
  ROLEPLAY_ROOM_GIRLS: 'roleplay-room-girls', // Uses roleplay rooms girls photos instead of generated ones (MAIN-1107)
  ARCHETYPE: 'archetype', // Enables dynamic archetype-based images in paywall and success pages based on user onboarding responses (MAIN-1060)
  ARCHETYPE_REAL_PHOTOS: 'archetype-real-photos', // Uses real images version of archetype images for paywall and success pages (MAIN-1060)
  SCALABLE_PAYWALL_IMAGE: 'scalable-paywall-image', // Makes paywall main image scalable (100% auto) instead of fixed size (540px auto)
  WEB_VERSION: 'web-version', // Remove the phrase "and download the app" on paywall (MAIN-1047)
  HOW_IT_WORKS_OPEN_APP: 'open-app-step-one', // How-it-works step 1: "open the App" (e.g. multigender-only-web + hasWebAppLink) vs "download"
  STORE_IMAGES: 'store-images', // Shows Google Play and App Store images under "Trusted by" message

  // Review cards
  REVIEWS_APP_STORE: 'reviews-app-store', // Uses App Store reviews content in PaywallUsersReviews component

  // Company branding
  REMOVE_DIALOGUE_REFERENCES: 'remove-dialogue-references', // Removes all Dialogue company references and branding across multigender layout (MAIN-1093)
  LURE_AI_BRANDING: 'lure-ai-branding', // Uses Lure AI branding instead of Dialogue
  LURE_APP_BRANDING: 'lure-app-branding', // Uses Lure App branding instead of Dialogue

  // TM layout character variants for paywall images
  TM_MAXIM_PHOTOS: 'tm-maxim-photos', // Uses Maxim character photos based on body_shape selection
  TM_THOMAS_PHOTOS: 'tm-thomas-photos', // Uses Thomas character photos based on body_shape selection

  // Header customization
  HIDE_APP_CAPTION: 'hide-app-caption', // Hides "by Pheon" caption in paywall header while keeping the logo

  // Terms and conditions
  REQUIRE_TERMS_CHECKBOX: 'require-terms-checkbox', // Requires explicit checkbox agreement on paywall with scroll & highlight (MAIN-1746)
  SHOW_SUBSCRIPTION_MANAGE_HINT: 'show-subscription-manage-hint', // Shows "You can manage or cancel your subscription..." under terms checkbox (Lure AI)
  SHOW_COMPANY_DETAILS_FOOTER: 'show-company-details-footer', // Shows company details footer after guarantee period on paywall and on success page (Lure AI)

  // Pool layout variants
  POOL_GIRL_IMAGE: 'pool-girl-image', // Uses pool girl image on paywall (MAIN-1632)

  // Color variants
  ALT_GRADIENT_COLORS: 'alt-gradient-colors', // Uses alternative gradient colors (#803EFF → #FF3636) for highlights and labels

  // Forest layout variants
  FOREST_IMAGES: 'forest-images', // Uses forest images based on gender and body_shape selection
  FOREST_TITLE: 'forest-title', // Uses forest-themed title on paywall

  // Payment method restrictions
  HIDE_APPLE_PAY_RECURRING_INFO: 'hide-apple-pay-recurring-info', // Hides recurring payment info and billing details from Apple Pay sheet (MAIN-1681)
  /** Send excluded_payment_methods: ['bank'] to /stripe_v2/payment (US bank account hidden for these campaigns) */
  EXCLUDED_PAYMENT_METHODS_BANK: 'excluded-payment-methods-bank',
} as const;

/**
 * Type definitions for layout notes
 */
export type LayoutNote = (typeof LAYOUT_NOTES)[keyof typeof LAYOUT_NOTES];

/**
 * Type definitions for paywall notes
 */
export type PaywallNote = (typeof PAYWALL_NOTES)[keyof typeof PAYWALL_NOTES];
